



























































































































import { Component, Prop, Watch } from "vue-property-decorator";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import {
  AtendimentoService,
  DadoAtendimento,
} from "@/services/atendimento.service";
import { date, dateTime, timeFromNow } from "@/shared/filters";
import ComboUsarioResponsavel from "@/shared/components/ComboUsarioResponsavel.vue";

@Component({
  components: { ComboUsarioResponsavel },
  filters: { date, dateTime, timeFromNow },
})
export default class DadosAtendimento extends mixins(GlobalMixin) {
  @Prop() idAtendimento!: number;
  dadoAtendimento: DadoAtendimento | null = null;
  tipoAssinatura: string | null = "";
  meioPagamento: string | null = "";
  loading = false;
  alteraResponsavel = false;
  idResponsavel: number | null = null;

  @Watch('dadoAtendimento')
  onDadoAtendimentoChange(val: any | null){
    this.$emit('atendimentoChange', val);
  }

  mounted() {
    this.fetchDadosAtendimento();
  }

  async fetchDadosAtendimento() {
    this.loading = true;
    try {
      this.dadoAtendimento = await AtendimentoService.PopAtendimento(
        this.idAtendimento
      );
      this.$emit("registrarChamadaAtivo", this.dadoAtendimento.aberto);
    } finally {
      this.loading = false;
    }
  }

  alterarResponsavel() {
    this.alteraResponsavel = true;
  }

  cancelar() {
    this.alteraResponsavel = false;
    this.idResponsavel = null;
  }

  async salvar() {
    this.loading = true;
    let idAtendimento = null;
    let idResponsavel = null;

    if (this.idAtendimento) {
      idAtendimento = Number(this.idAtendimento);
    }
    if (this.idResponsavel) {
      idResponsavel = Number(this.idResponsavel);
    }
    try {
      if (idAtendimento) {
        await AtendimentoService.AlterarResponsavel(
          idAtendimento,
          idResponsavel
        );
      }
    } finally {
      this.loading = false;
      this.alteraResponsavel = false;
      this.idResponsavel = null;
      this.atualizaAtendimento();
    }
  }

  async atualizaAtendimento() {
    this.loading = true;
    try {
      this.dadoAtendimento = await AtendimentoService.AtualizaAtendimento(
        this.idAtendimento
      );
    } finally {
      this.loading = false;
    }
  }
}
